import { handleActions } from "redux-actions";

const initialState = {
    data: [],
    loading: false,
    error: null,
    //Available null nos dira si el objeto ya esta listo
    //o si esta en default
    onEditionLoad: {
        available: null,
        station: "",
        slot: 0,
        date_beginning: "",
        date_end: "",
        kwh: 0,
        company: "",
        cost: 0,
        client_id: "",
    }
}

export default handleActions({
    UPDATE_LOADS: (state, action) => ({
        ...state,
        data: action.payload
    }),
    SAVE_Load_INFO: (state, action) => {
        return{
            ...state,
            onEditionLoad: action.payload
        }
    }
}, initialState)